import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  SHOW_WITH_PROFILE_ID,
  CLUB_VIDEOS_INDEX,
  CLUB_UPDATE_URL,
  UPLOAD_IMAGE_LOGO,
  DELETE_CLUB_VIDEO_URL,
  SAVE_CLUB_VIDEO_URL,
  UPDATE_CLUB_VIDEO_URL,
  CHECK_CLUB_NAME,
  CREATE_CLUB,
  UPLOAD_CLUB_IMAGES,
  DELETE_CLUB_IMAGES,
  GET_ALL_CLUBS,
  UPDATE_VIEW_COUNT_CLUB
} from "@/utils/api-url";

class Club extends Base {
  constructor(params = {}) {
    super(params);
    this.key = params["_id"] || this.Id || this.key || "";
    this.id = params["_id"] || params["id"];
    this.name = params && params.clubName;
    this.stateName = params && params.state && params.state.name;
    this.ageGroup = params && params.age && params.age.name;
    this.state = (params["state"] && params["state"]["name"]) || this.state;
    this.stateId = (params["state"] && params["state"]["_id"]) || this.stateId;
    this.ageGroup =
      (params["age"] && params["age"]["name"]) || this.ageGroup || "";
    this.ageGroupId =
      this.ageGroupId || (params["age"] && params["age"]["_id"]) || "";
    this.coachDowngraded = params["coachDowngraded"] || false;
  }

  static resourceName() {
    return "club";
  }

  static show(params) {
    let profileId = "";
    if (JSON.parse(localStorage["user-permissions"]) === "player")
      profileId = this.profileId();
    return apiDispatcher(SHOW_WITH_PROFILE_ID(params, "club", profileId));
  }

  static validationRules = {
    clubName: [{ required: true, message: "Club name is required" }],
    city: [{ required: true, message: "City is required" }],
    stateId: [{ required: true, message: "State is required" }],
    address1: [{ required: false, message: "Address is required" }],
    zip: [{ required: true, message: "ZIP CODE is required" }],
    ageGroupId: [{ required: true, message: "Age group is required" }],
    clubPhone: [{ required: true, message: "Number is required" }]
  };

  static update(params) {
    return apiDispatcher(CLUB_UPDATE_URL(params));
  }

  static getVideos(params) {
    return apiDispatcher(CLUB_VIDEOS_INDEX(params));
  }

  static getVideosLimited(params) {
    return apiDispatcher(CLUB_VIDEOS_INDEX({ ...params, limit: 3, page: 1 }));
  }

  static updateClubLogo(params) {
    const id = params.id;
    return apiDispatcher(UPLOAD_IMAGE_LOGO("club", id, params.image));
  }

  static deleteClubVideos(params) {
    return apiDispatcher(DELETE_CLUB_VIDEO_URL(params));
  }

  static saveClubVideos(params) {
    return apiDispatcher(SAVE_CLUB_VIDEO_URL(params));
  }

  static updateClubVideos(params) {
    return apiDispatcher(UPDATE_CLUB_VIDEO_URL(params));
  }

  static checkClubName(params) {
    return apiDispatcher(CHECK_CLUB_NAME(params));
  }

  static createClub(data) {
    return apiDispatcher(CREATE_CLUB(data));
  }

  static uploadClubImages(data) {
    return apiDispatcher(UPLOAD_CLUB_IMAGES(data));
  }

  static deleteClubImages(data) {
    return apiDispatcher(DELETE_CLUB_IMAGES(data));
  }

  static getAllClubs(params) {
    return apiDispatcher(GET_ALL_CLUBS(params));
  }

  static updateViewCount(params) {
    const profileId = this.profileId()

    return apiDispatcher(UPDATE_VIEW_COUNT_CLUB(params, profileId));
  }

  static ageGroup() {
    return [
      { label: "18U", value: "18u" },
      { label: "16U", value: "16u" },
      { label: "12U", value: "16u" }
    ];
  }

  static filterConfig() {
    return [
      {
        component: "BaseInput",
        placeholder: "Club Name",
        column: "q",
        searchType: "query",
        additionalData: { searchField: "clubName", sort:"clubName" },
        gridComponent: "one"
      },
      {
        component: "BaseTaxonomySelect",
        resource: "ageGroup",
        type: "Age Group",
        placeholder: "Age Group",
        allowClear: true,
        column: "age",
        searchType: "normal",
        gridComponent: "two"
      },
      {
        component: "BaseSortedTaxonomySelect",
        resource: "state",
        type: "State",
        placeholder: "State",
        allowClear: true,
        column: "state",
        searchType: "normal",
        gridComponent: "three",
        optionFilterProp: "children",
        showSearch: true,
        filterOption: true
      },
      {
        component: "BaseButton",
        type: "primary",
        class: "btn btn-default primary-button-club-class",
        searchType: "Submit",
        gridComponent: "four",
        label: "Search",
        clickable: true
      }
    ];
  }
}

export default Club;
